class DestinationRoute extends HTMLElement {
  connectedCallback() {
    this.links = [...this.querySelectorAll('[data-destination-route-link]')];
    this.cards = [...this.querySelectorAll('[data-destination-route-card]')];
    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    this.handleLinkClick = this.handleLinkClick.bind(this);
    this.handleBlockSelect = this.handleBlockSelect.bind(this);

    this.links.forEach((link) => link.addEventListener('click', this.handleLinkClick));
    document.addEventListener('shopify:block:select', this.handleBlockSelect);

    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(
        (entries) => {
          const activeEntry = entries
            .filter((entry) => entry.isIntersecting)
            .sort((first, second) => second.intersectionRatio - first.intersectionRatio)[0];

          if (activeEntry) this.setActive(activeEntry.target.id);
        },
        {
          rootMargin: '-18% 0px -52% 0px',
          threshold: [0.15, 0.35, 0.6],
        }
      );

      this.cards.forEach((card) => this.observer.observe(card));
    }
  }

  disconnectedCallback() {
    this.links?.forEach((link) => link.removeEventListener('click', this.handleLinkClick));
    document.removeEventListener('shopify:block:select', this.handleBlockSelect);
    this.observer?.disconnect();
  }

  setActive(cardId) {
    this.links?.forEach((link) => {
      const isActive = link.dataset.destinationRouteLink === cardId;
      link.classList.toggle('is-active', isActive);

      if (isActive) {
        link.setAttribute('aria-current', 'true');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }

  handleLinkClick(event) {
    const link = event.currentTarget;
    const cardId = link.dataset.destinationRouteLink;
    const card = this.querySelector(`#${CSS.escape(cardId)}`);

    if (!card) return;

    event.preventDefault();
    this.setActive(cardId);
    card.scrollIntoView({
      behavior: this.prefersReducedMotion.matches ? 'auto' : 'smooth',
      block: 'start',
    });

    if (window.history?.replaceState) {
      window.history.replaceState(null, '', `#${cardId}`);
    }
  }

  handleBlockSelect(event) {
    const card = event.target.closest?.('[data-destination-route-card]');

    if (!card || !this.contains(card)) return;

    this.setActive(card.id);
    card.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}

if (!customElements.get('destination-route')) {
  customElements.define('destination-route', DestinationRoute);
}
